import React, { useMemo, useEffect } from 'react';
import base64url from '../../../../../utils/base64/base64url';
import ChallengeView from './ChallengeView';

type Props = {
  challengeShopperData: any;
};

const ChallengeContainer = ({ challengeShopperData }: Props) => {
  const { threeDSServerTransID, acsTransID, messageVersion, acsURL } =
    challengeShopperData;

  const encodedcReq = useMemo(() => {
    const cReqData = {
      threeDSServerTransID,
      acsTransID,
      messageVersion,
      challengeWindowSize: '05',
      messageType: 'CReq',
    };
    const stringifiedDataObject = JSON.stringify(cReqData);
    return base64url.encode(stringifiedDataObject);
  }, [threeDSServerTransID, acsTransID, messageVersion]);

  useEffect(() => {
    // This function will handle the challenge response
    const handleChallengeResponse = (event: MessageEvent) => {
      try {
        console.log('Received message:', event);
      } catch (error) {
        console.error('Error handling challenge response:', error);
      }
    };

    window.addEventListener('message', handleChallengeResponse);

    return () => {
      window.removeEventListener('message', handleChallengeResponse);
    };
  }, [threeDSServerTransID]);

  console.log('ChallengeView');
  return (
    <>
      <ChallengeView acsURL={acsURL} encodedcReq={encodedcReq} />
    </>
  );
};

export default ChallengeContainer;
